var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaterD2C43997Ba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28a10.69 10.69 0 0 1-1.13-.06 10.08 10.08 0 0 1-7-16v-.05l4.92-8.1A3.73 3.73 0 0 1 15 2h0a3.74 3.74 0 0 1 3.2 1.79l5.42 8.85.06.12a10.1 10.1 0 0 1-2 12.64A10 10 0 0 1 15 28zM8.23 12.58a.81.81 0 0 1-.1.18 8.55 8.55 0 0 0-1.69 6 8.72 8.72 0 0 0 7.61 7.73 8.51 8.51 0 0 0 6.69-2.15 8.58 8.58 0 0 0 1.59-10.86.37.37 0 0 1 0-.11l-5.4-8.78A2.25 2.25 0 0 0 15 3.52h0a2.21 2.21 0 0 0-1.91 1.08z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.13,
    cy: 19.96,
    r: 2.1,
    fill: "#40d0cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaterD2C43997Ba);
export default __webpack_public_path__ + "static/media/icon_water_d2c43997ba.d3c28894063315d73027211cd7e362fe.svg";
export { ForwardRef as ReactComponent };